import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
  onClick?: () => void;
}
export function AccordionItem({
  title,
  children,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-gray-200 last:border-0" data-id="element-294">
      <button className="w-full py-4 px-2 flex items-center justify-between text-left focus:outline-none group" onClick={onClick} data-id="element-295">
        <span className="text-lg font-medium text-gray-900 group-hover:text-[#4A6741] transition-colors pr-4" data-id="element-296">
          {title}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-[#4A6741] flex-shrink-0" data-id="element-297" /> : <ChevronDown className="w-5 h-5 text-gray-400 group-hover:text-[#4A6741] flex-shrink-0" data-id="element-298" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-299">
        <div className="px-2 text-gray-600 leading-relaxed" data-id="element-300">{children}</div>
      </div>
    </div>;
}
interface AccordionProps {
  items: {
    title: string;
    content: React.ReactNode;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const handleClick = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="w-full max-w-3xl mx-auto bg-white rounded-2xl shadow-sm border border-gray-100 p-4 md:p-6" data-id="element-301">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} isOpen={openIndex === index} onClick={() => handleClick(index)} data-id="element-302">
          {item.content}
        </AccordionItem>)}
    </div>;
}